import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import App from './App';
import router from '@/router';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

Vue.config.productionTip = false;

let dsn = process.env.VUE_APP_SENTRY_DSN;
if (typeof dsn !== 'undefined') {
  Sentry.init({
    Vue: Vue,
    dsn: dsn,
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

new Vue({
  router,
  vuetify,
  components: { App },
  render: (h) => h(App),
}).$mount('#app');
